import Vue from "vue";
import api from '@/api.js';
const state = {
    tasks: {},
    taskFilters: {
        years: [],
        firms: [],
        projects: []
    },
};
const mutations = {
    setTasks(state, tasks) {
        state.tasks = tasks;
    },
    setTaskFilters(state, options) {
        state.taskFilters = options;
    },
    updateTask(state, task) {
        console.log('update task', task);
        task.running = Array.isArray(task.times) && task.times.some(t => t.status === 0);
        Vue.set(state.tasks, task.id, task);
    },
    updateTimer(state, timer) {
        const task = state.tasks[timer.taskId];
        if (task) {
            const index = task.times.findIndex(time => time.id == timer.id);
            if (index >= 0) {
                Vue.set(task.times, index, timer); // Ersetzen für Reaktivität
            }
            else {
                task.times.push(timer);
            }
            Vue.set(state.tasks, timer.taskId, { ...task }); // Reaktivität erzwingen
        }
    },
};
const getters = {
    tasks: state => state.tasks,
    tasksArray: state => Object.values(state.tasks),
    taskFilters: state => state.taskFilters,
    activeTasks: state => {
        return Object.values(state.tasks).filter(task => task.taskStatus == 0 && !task.hidden);
    },
};
const actions = {
    async getTasks({ commit }, params) {
        const res = await api.worktime.tasks(params);
        commit('setTasks', res.data);
        return res.data;
    },
    async getTaskFilters({ commit }) {
        const res = await api.worktime.taskFilters();
        commit("setTaskFilters", res.data);
    },
    async fetchTasks({ commit }, params) {
        const res = await api.worktime.tasks(params);
        console.log('fetch tasks', res.data);
        return res.data;
    },
    async saveTask({ commit }, task) {
        console.log('save task', task);
        const res = await api.worktime.saveTask(task);
        console.log('save task.1', res.data);
        commit("updateTask", res.data);
        return res.data;
    },
};
export const Tasks = {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
};
